<template>
  <v-row justify="center" align="center">
    <v-col xs="6" md="4" class="">
      <h1 class="text-center primary--text">404</h1>
      <p class="text-center grey--text darken-2">{{ message[locale] }}</p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "notFound",
  data() {
    return {
      message: {
        sv: "Kunde inte hitta resursen",
        en: "Could not find resource"
      }
    };
  },
  computed: {
    locale() {
      return this.$store.getters.GET_LOCALE.value;
    }
  }
};
</script>

<style></style>
